// 兼容IE
import "babel-polyfill";

// import 'es6-promise/auto'

import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n

import "@/styles/index.scss"; // global css

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
// import 'swiper/css/swiper.css'

import App from "./App";
import router from "./router";
import store from "./store";

// import '@/icons' // icon
import "@/permission"; // permission control

// md5加密
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

Vue.use(ElementUI, { locale });
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js